import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../config';
import './BuscadorSocios.css';

function BuscadorSocios() {
  const [filtros, setFiltros] = useState({ nombreCompleto: '', documento: '', numeroSocio: '' });
  const [resultados, setResultados] = useState([]);
  const [error, setError] = useState('');
  const [paginacion, setPaginacion] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  });
  const [paginaActual, setPaginaActual] = useState(1);
  const navigate = useNavigate();

  const handleChange = e => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleBuscar = async (e, pagina = 1) => {
    if (e) e.preventDefault();
    setError('');
    setPaginaActual(pagina);
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      Object.entries(filtros).forEach(([k, v]) => { if (v) params.append(k, v); });
      params.append('page', pagina);
      params.append('limit', 10);
      const res = await fetch(`${API_ENDPOINTS.SOCIOS}?${params.toString()}`, {
        headers: { 'Authorization': 'Bearer ' + token }
      });
      const data = await res.json();
      if (res.ok) {
        setResultados(data.socios || []);
        setPaginacion(data.pagination || {
          currentPage: 1,
          totalPages: 0,
          totalItems: 0,
          itemsPerPage: 10
        });
      } else {
        setError(data.message || 'Error en la búsqueda');
      }
    } catch (err) {
      setError('Error de red');
    }
  };

  const handleCambiarPagina = (nuevaPagina) => {
    handleBuscar(null, nuevaPagina);
  };

  return (
    <div className="panel-socio-bg">
      <div className="buscador-socios-card">
        <h2 className="panel-socio-title">Buscador de Socios</h2>
        
        <form onSubmit={handleBuscar} className="panel-socio-form">
          <div className="form-filtros">
            <div className="form-field-group">
              <label htmlFor="nombreCompleto">Nombre Completo</label>
              <input 
                id="nombreCompleto"
                name="nombreCompleto" 
                placeholder="Ingrese nombre completo" 
                value={filtros.nombreCompleto} 
                onChange={handleChange} 
              />
            </div>
            
            <div className="form-field-group">
              <label htmlFor="documento">Documento</label>
              <input 
                id="documento"
                name="documento" 
                placeholder="Ingrese documento" 
                value={filtros.documento} 
                onChange={handleChange} 
              />
            </div>
            
            <div className="form-field-group">
              <label htmlFor="numeroSocio">Número de Socio</label>
              <input 
                id="numeroSocio"
                name="numeroSocio" 
                placeholder="Ingrese número de socio" 
                value={filtros.numeroSocio} 
                onChange={handleChange} 
              />
            </div>
          </div>
          
          <button type="submit" className="btn-buscar">Buscar Socios</button>
        </form>
        
        {error && <div className="panel-socio-error">{error}</div>}
        
        {resultados.length > 0 ? (
          <div className="tabla-container">
            <table className="resultados-tabla">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Nombre</th>
                  <th>Documento</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {resultados.map(s => (
                  <tr key={s.id}>
                    <td>{s.numeroSocio}</td>
                    <td>{s.nombreCompleto}</td>
                    <td>{s.documento}</td>
                    <td>
                      <button 
                        className="btn-ver-editar"
                        onClick={() => navigate(`/admin/editar-socio/${s.id}`)}
                      >
                        Ver/Editar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : resultados.length === 0 && !error ? (
          <div className="sin-resultados">
            No se encontraron socios. Realice una búsqueda para ver resultados.
          </div>
        ) : null}
        
        {/* Paginación */}
        {paginacion.totalPages > 1 && (
          <div className="paginacion">
            <div className="paginacion-info">
              Mostrando {((paginacion.currentPage - 1) * paginacion.itemsPerPage) + 1} - {Math.min(paginacion.currentPage * paginacion.itemsPerPage, paginacion.totalItems)} de {paginacion.totalItems} resultados
            </div>
            <div className="paginacion-controles">
              <button 
                className="btn-pagina"
                disabled={paginacion.currentPage === 1}
                onClick={() => handleCambiarPagina(paginacion.currentPage - 1)}
              >
                Anterior
              </button>
              
              {Array.from({ length: Math.min(5, paginacion.totalPages) }, (_, i) => {
                const pagina = i + 1;
                return (
                  <button
                    key={pagina}
                    className={`btn-pagina ${paginacion.currentPage === pagina ? 'activa' : ''}`}
                    onClick={() => handleCambiarPagina(pagina)}
                  >
                    {pagina}
                  </button>
                );
              })}
              
              {paginacion.totalPages > 5 && (
                <>
                  {paginacion.currentPage > 3 && <span className="paginacion-ellipsis">...</span>}
                  <button
                    className={`btn-pagina ${paginacion.currentPage === paginacion.totalPages ? 'activa' : ''}`}
                    onClick={() => handleCambiarPagina(paginacion.totalPages)}
                  >
                    {paginacion.totalPages}
                  </button>
                </>
              )}
              
              <button 
                className="btn-pagina"
                disabled={paginacion.currentPage === paginacion.totalPages}
                onClick={() => handleCambiarPagina(paginacion.currentPage + 1)}
              >
                Siguiente
              </button>
            </div>
          </div>
        )}
        
        <div className="panel-socio-botones">
          <button 
            className="btn-panel-socio btn-accion"
            onClick={() => navigate('/admin')}
          >
            Volver al Panel
          </button>
        </div>
      </div>
    </div>
  );
}

export default BuscadorSocios; 